import { mappable } from '../decorators';
import { endpoint } from '../decorators/endpoint.decorator';
import { BaseViewModel } from './base-view-model';
import { RequestorViewModel } from './requestor-view-model';

@endpoint('contactdetail')
export class ContactDetailViewModel extends BaseViewModel {
  public RequestorId = 0;
  public AddressType = '';
  public Phone = '';
  public Email = '';
  public Address1 = '';
  public Address2 = '';
  public City = '';
  public State = '';
  public Country = '';
  public PostalCode = '';
  public PreferContactBy = '';
  public PrimaryContact = false;
  public Notes = '';

  /** The person with whom this contact detail record is associated. */
  @mappable('RequestorViewModel')
  public Requestor: RequestorViewModel;
}
